import type { MegaNavItem } from '../types';

export const megaNavData: MegaNavItem[] = [
  {
    name: 'Buy',
    href: '/homes',
    sections: [
      {
        title: 'Homes for sale',
        links: [
          { name: 'For sale in California', href: '/homes/california' },
          { name: 'For sale in Texas', href: '/homes/texas' },
          { name: 'For sale in Florida', href: '/homes/florida' },
        ],
      },
      {
        title: 'Homebuying',
        links: [
          { name: 'How to buy a house', href: '/buy/how-to-buy' },
          { name: 'Buy at the right time', href: '/buy/timing' },
          { name: 'Buy at the right price', href: '/buy/should-i-buy' },
        ],
      },
      {
        title: 'Tools',
        links: [{ name: 'Mortgage calculator', href: '/tools/mortgage-calculator' }],
      },
    ],
  },
  {
    name: 'Sell',
    href: '/sell',
    sections: [
      {
        title: 'Our offer',
        links: [
          { name: 'Sell to Opendoor', href: '/sell/your-way' },
          { name: 'Home sale calculator', href: '/sell/calculator' },
          { name: 'Work with a builder', href: '/sell/builder' },
        ],
      },
      {
        title: 'Home selling resources',
        links: [
          { name: 'Sell my home for cash', href: '/sell/cash' },
          { name: 'Selling costs', href: '/sell/how-to-sell' },
          { name: 'Selling timelines', href: '/sell/timeline' },
        ],
      },
    ],
  },
  {
    name: 'Agents',
    href: '/agents',
    sections: [
      {
        title: 'For agents',
        links: [{ name: 'Become a partner agent', href: '/agents/become-key-agent' }],
      },
      {
        title: 'Agent resources',
        links: [
          { name: 'Get started as an agent', href: '/agents/how-to-become' },
          { name: 'Get your license', href: '/agents/salary' },
          { name: 'Licensing timelines', href: '/agents/license' },
        ],
      },
    ],
  },
];
